import _flatpickr from 'flatpickr';
import _confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js';

export const flatpickr = _flatpickr as unknown as typeof _flatpickr.default;
export const confirmDatePlugin =
  _confirmDatePlugin as unknown as typeof _confirmDatePlugin.default;
